import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { getPromos } from '../../selectors/item-retailer';

import type { RetailerPromo } from '../../@types/Retailer';
import OverflowGrid from '../../components/overflow-grid';
import { H3 } from '../../styled-components/components/Heading';
import { StackMedium } from '../../styled-components/components/Stack';
import Promo from './promo';
import PromoModal from './promo-modal';

const Promos = () => {
  const { t } = useTranslation(['item']);
  const promos = useSelector(getPromos);
  const [modal, setModal] = useState<RetailerPromo | null>(null);
  if (!promos) return null;

  const hasNoItems = promos.length === 0;

  if (hasNoItems) return null;

  const onClick = (promo: RetailerPromo) => setModal(promo);

  return (
    <>
      {modal && <PromoModal promo={modal} onClose={() => setModal(null)} />}
      <div className="item-section item-section-full-width">
        <StackMedium>
          <H3 as="h2" $margin="none">
            {t('Offers', { ns: 'item' })}
          </H3>
        </StackMedium>
        <StackMedium>
          <OverflowGrid visibleItems={3} modifiers="offset-button-3:2">
            {promos.map((promo, index) => (
              <Promo
                key={`${promo.title || ''}-${index}`}
                promo={promo}
                onClick={() => onClick(promo)}
              />
            ))}
          </OverflowGrid>
        </StackMedium>
      </div>
    </>
  );
};

export default Promos;
